import {LogoWithLabel} from '@shared/components/Logo/LogoWithLabel'
import type {CSSProperties} from 'react'
import {DateTimeService} from 'swayok-react-mdb-ui-kit/services/DateTimeService'
import {appUrl} from '../../../AppUrl'
import {trans} from '../../../helpers'
import {useRegionConfig} from '../../../hooks'

interface TopNavigationLogoProps {
    isMobile?: boolean
    showLabel?: boolean
    short?: boolean
}

// Логотип в верхнем меню навигации.
// Иногда используется event лого вместо стандартного.
export function TopNavigationLogo(props: TopNavigationLogoProps) {

    const {
        isMobile,
        showLabel = false,
        short = false,
    } = props

    const regionConfig = useRegionConfig()

    const url: string = appUrl().index
    const label: string = regionConfig.logoSubtitle
    const alt: string = trans().common.app_name
    const defaultLogo = (
        <LogoWithLabel
            url={url}
            label={showLabel ? label : null}
            alt={alt}
            short={short}
            className="top-nav-logo"
        />
    )

    // Логотип события.
    const showDefaultLogoTogetherWithEventLogo = false
    const eventStartDate = DateTimeService.parse(new Date('2026-09-17 00:00:00'))
    const eventEndDate = DateTimeService.parse(new Date('2026-09-30 00:00:00'))
    const eventLogoUrl = '/img/dotoku-event.svg?ts=' + eventStartDate.format('YYYYMMDD')
    const eventLogoWrapperStyle: CSSProperties = isMobile
        ? {}
        : {
            height: 42,
        }
    const eventLogoStyle: CSSProperties = isMobile
        ? {}
        : (
            showLabel
                ? {
                    height: 77,
                    marginTop: -6,
                }
                : {
                    height: 60,
                    marginTop: -10,
                }
        )

    if (
        DateTimeService.now().isAfter(eventStartDate)
        && DateTimeService.now().isBefore(eventEndDate)
    ) {
        // Логотип события.
        return (
            <>
                <LogoWithLabel
                    url={url}
                    label={showLabel ? label : null}
                    alt={alt}
                    short={short}
                    fullLogoUrl={eventLogoUrl}
                    fullLogoStyle={eventLogoStyle}
                    fullLogoWrapperStyle={eventLogoWrapperStyle}
                    logoLabelStyle={{
                        marginTop: 7,
                        marginRight: 17,
                    }}
                />
                {showDefaultLogoTogetherWithEventLogo && defaultLogo}
            </>
        )
    }

    return defaultLogo
}
